import { SalesforceProfileModel } from "@api/types/salesforceprofile";
import { httpClient } from "../../httpClient";

type Data = any;

type GetSalesforceProfilesResponse = {
  salesforceProfiles: SalesforceProfileModel[];
};

const salesforceWebApi = "/api/v1/salesforce/profiles/";

export async function getSalesforceProfile(): Promise<
  GetSalesforceProfilesResponse
> {
  try {
    const { data } = await httpClient.get(salesforceWebApi);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function getSalesforceProfileById(id: number): Promise<any> {
  try {
    const { data } = await httpClient.get(`${salesforceWebApi}${id}`);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function postSalesforceProfile(
  payload: SalesforceProfileModel
): Promise<void> {
  try {
    const { data } = await httpClient.post<Data>(salesforceWebApi, payload);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function putSalesforceProfile(
  id: number,
  payload: SalesforceProfileModel
): Promise<any> {
  try {
    const { data } = await httpClient.put<Data>(
      `${salesforceWebApi}${id}`,
      payload
    );
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export const salesforceprofile = {
  getSalesforceProfile,
  getSalesforceProfileById,
  postSalesforceProfile,
  putSalesforceProfile,
};
